/**
 * API LLM transverses (translate batch, proofread on-blur).
 *
 * - `translate` affiche le panneau « Analyse visuelle » de `WorkDetailPage`
 *   en FR sans toucher la DB — traduction en RAM via TanStack Query.
 * - `proofread` corrige fautes/grammaire/typo on-blur sur les champs
 *   story_fr / description_fr / notes (NewWorkPage). Pas de reformulation,
 *   prompt court, ~$0.0005 par appel.
 */

import { apiClient } from './client'
import type { components } from '@/types/api-generated'

export type TranslateRequest = components['schemas']['TranslateRequest']
export type TranslateResponse = components['schemas']['TranslateResponse']
export type ProofreadRequest = components['schemas']['ProofreadRequest']
export type ProofreadResponse = components['schemas']['ProofreadResponse']

export const llmApi = {
  translate: async (payload: TranslateRequest): Promise<TranslateResponse> => {
    const { data } = await apiClient.post<TranslateResponse>('/llm/translate', payload, {
      timeout: 30_000,
    })
    return data
  },

  proofread: async (payload: ProofreadRequest): Promise<ProofreadResponse> => {
    const { data } = await apiClient.post<ProofreadResponse>('/llm/proofread', payload, {
      timeout: 20_000,
    })
    return data
  },
}
